import React from 'react';
import classNames from 'classnames';
import { classes } from './field-label-wut.st.css';
import { RequiredIndicator, RequiredIndicatorPlacement as Placement } from '@wix/ambassador-forms-v4-form/types';
import { useTranslation } from '../../contexts/translation-context';
export const FieldLabelWUT = _ref => {
  let {
    labelId,
    htmlFor,
    label,
    required = false,
    hideLabel = false,
    requiredIndicatorHidden = false,
    requiredIndicatorType = RequiredIndicator.ASTERISK,
    requiredIndicatorPlacement = Placement.AFTER_FIELD_TITLE
  } = _ref;
  const Tag = htmlFor ? 'label' : 'div';
  const {
    t
  } = useTranslation();
  const labelAfterRequiredIndicator = requiredIndicatorType === RequiredIndicator.ASTERISK && requiredIndicatorPlacement === Placement.BEFORE_FIELD_TITLE;
  return /*#__PURE__*/React.createElement(Tag, {
    id: labelId,
    htmlFor: htmlFor,
    className: classNames(classes.label, {
      [classes.hidden]: hideLabel
    })
  }, !labelAfterRequiredIndicator && label, required && !requiredIndicatorHidden && /*#__PURE__*/React.createElement("span", {
    className: classes.requiredIndicator,
    "aria-hidden": "true"
  }, requiredIndicatorType === RequiredIndicator.ASTERISK && '*', requiredIndicatorType === RequiredIndicator.TEXT && /*#__PURE__*/React.createElement("span", {
    className: classes.requiredText
  }, t('settings.required-indicator.text'))), labelAfterRequiredIndicator && label);
};
//# sourceMappingURL=field-label-wut.js.map